import style from './Emptyfav.module.scss';

export const EmptyFav = () => {
  return (
    <div className={style.cart}>
      <div className={style.cart__cat}></div>
    </div>
  );
};
